import { render } from "./GreenIndustrial.vue?vue&type=template&id=2cd1e6f3"
import script from "./GreenIndustrial.vue?vue&type=script&lang=js"
export * from "./GreenIndustrial.vue?vue&type=script&lang=js"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__